import { SPIScorecardTab } from "@/components/spi/SPIScorecardTab";
import { useProductDetailContext } from "@/contexts/ProductDetailContext";

export default function ProductContentScorecardPage() {
  const { productDetail } = useProductDetailContext();

  return (
    <div className="p-6 [&_table]:border-0 [&_.v2-table-section]:rounded-none [&_.v2-table-section]:border-x-0 [&_.v2-table-section]:border-b-0">
      <SPIScorecardTab asin={productDetail.asin} productId={productDetail.id} />
    </div>
  );
}
